import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { ORGANIZATION_FEATURE_GROUP } from './group';

export const ORGANIZATION_FEATURES = {
  CREATE: {
    guid: '2c1116e5-71b2-4be0-90cc-cf6a11850000',
    name: 'organization:create',
    description: 'Create a new organization',
    action: 'create',
    product: 'account',
    parentGuid: ORGANIZATION_FEATURE_GROUP.guid,
  },
  READ: {
    guid: '2c1116e5-71b2-4be0-90cc-cf6a11850001',
    name: 'organization:read',
    description: 'View organization details and settings',
    action: 'read',
    product: 'account',
    parentGuid: ORGANIZATION_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: '2c1116e5-71b2-4be0-90cc-cf6a11850002',
    name: 'organization:update',
    description: 'Edit organization settings, name, and contact information',
    action: 'update',
    product: 'account',
    parentGuid: ORGANIZATION_FEATURE_GROUP.guid,
  },
  DELETE: {
    guid: '2c1116e5-71b2-4be0-90cc-cf6a11850003',
    name: 'organization:delete',
    description: 'Permanently delete the organization and all its data',
    action: 'delete',
    product: 'account',
    parentGuid: ORGANIZATION_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ORGANIZATION_FEATURE_GROUP } from './group';

export const ORGANIZATION_MODULE: FeatureModule = {
  product: 'account',
  groups: [ORGANIZATION_FEATURE_GROUP],
  features: featureList(ORGANIZATION_FEATURES),
};
